import { UserService } from './User.types'
import {
  CreateUserDTO,
  exampleUser,
  UserWithBusiness,
  Auth0User,
  PostResponse,
} from '@marketing-milk/interfaces'

let exampleAuth0User: Auth0User

export class UserServiceMock implements UserService {
  async create(userDTO: CreateUserDTO) {
    return {
      errors: [],
      data: { user: exampleUser as UserWithBusiness, message: 'User successfully created' },
    }
  }
  async invite(userDTO: CreateUserDTO) {
    return {
      errors: [],
      data: { invitedUser: exampleUser as UserWithBusiness, message: 'User successfully invited' },
    }
  }
  async getInvites() {
    return { invites: [], count: 0 }
  }
  async getInvitedByUsers() {
    return [] as any
  }
  async resendInvite(email: string) {
    return { errors: [], data: { message: '' } }
  }
  async deleteInvite(email: string) {
    return
  }
  async getSignupLink(email: string) {
    return { signupUrl: `https://example.com/signup?issueToken=${encodeURIComponent(email)}` }
  }
  async getAll() {
    return [exampleUser] as UserWithBusiness[]
  }
  async getAllAuth0Users() {
    return [exampleAuth0User] as Auth0User[]
  }
  async getByID(userID: number) {
    return exampleUser as UserWithBusiness
  }
  async updateByID(userID: number) {}
  async deleteByID(userID: number) {}
  async getAuth0User(userId: number) {
    return exampleAuth0User as Auth0User
  }
  async searchAuth0UsersByConnection(email: string, connection: string) {
    return [] as Auth0User[]
  }
  async linkGoogle(userId: number, secondaryUserId?: string) {}
  async linkFacebook(userId: number, idToken: string) {}
  async linkIdentityByToken(userId: number, linkWith: string) {}
  async linkIdentityById(userId: number, provider: string, secondaryUserId: string) {}
  async unlinkIdentity(userId: number, provider: string, secondaryUserId: string) {}
}
